// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"c3340d62","253":"c34005b2","488":"b9064261","544":"86f6a48e"}[chunkId] + ".chunk.js";
};